import 'babel-polyfill'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VueI18n from 'vue-i18n'
import {APISetting}  from './library/APICaller'
import APICaller from './library/APICaller'
import router from './router'
import store from './store'
import axios from 'axios'
import Plugins from './plugins'
import ko from './lang/kr'
import * as Keycloak from 'keycloak-js'
import MainService from './services/MainService'
import UrlsConfig from './config/urls.conf'
import { LICENSE_KEY_AG_GRID } from './constants/constants';
import {LicenseManager} from "ag-grid-enterprise";
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import App from './App.vue'
import moment from "moment";

Vue.config.productionTip = false
LicenseManager.setLicenseKey(LICENSE_KEY_AG_GRID);
//amchart
am4core.useTheme(am4themes_animated);
am4core.options.commercialLicense = true;
if (process.env.NODE_ENV !== 'production') {
  APISetting.debugMode = true
}

Vue.use(Plugins)
Vue.use(VueI18n)
Vue.use(VueCookies)

Vue.filter('comma', (value) => {
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
})
const messages = {
  ko
}

// VueI18n instance
const i18n = new VueI18n({
  locale: 'ko',
  messages
})

var keycloak;
MainService.getProfile().then(function(result){
  if(!result.data && result.data.code != 0){
    //TODO  backend profile error handling
    return;
  }

  let profileData = result.data.resultData;
  UrlsConfig.init(profileData.env); //  profile 에 따라  token key 및 인증 서버 url 결정.
  profileData['clientId'] = UrlsConfig.clientId;
  keycloak = Keycloak(profileData);
  keycloak['onAuthLogout'] = clearLocalCookieAndState;
  keycloak["onAuthRefreshError"] = doLogin;
  keycloak.init({
    flow:  'standard',
    onLoad: 'login-required',
    checkLoginIframe: false,
  }).then((auth) =>{
    if(!auth){
      keycloak.login();
    }
    VueCookies.set(UrlsConfig.session_timestamp_key, keycloak.refreshTokenParsed["exp"], '1y', '/', getTopDomain());
    //Vue.prototype.$keycloak = keycloak;
    window.urlsConfig = UrlsConfig;
    window.keycloak = keycloak
    APICaller.interceptors.start();

    new Vue({
      i18n,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')

  }).catch((e) =>{
    //TODO  init keycloak error handling
    console.log(e);
    console.log('error init keycloak ');
  });
});



function clearLocalCookieAndState(){
  VueCookies.remove(UrlsConfig.session_timestamp_key, '/', getTopDomain());
}

function doLogin(){
  window.keycloak.login();
}
function getTopDomain(){
  var url = new URL(window.location.href);
  return "." + url.hostname.split(/\./).slice(-2).join('.');
}



// WEBPACK FOOTER //
// ./src/main.js